import React, { useEffect, useState } from "react";
import { Row, Col, Tab, Tabs, Form, Card, Button } from "react-bootstrap";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import Avatar from "../../assets/img/User3.jpg";
import { fileUpload, UpdateUserProfile } from "../../api/userService";
import { useNavigate } from "react-router-dom";
import { refreshTokenFn } from "../../middlewares/tokenFunction";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getProfile,
  updateProfile,
  passwordChange,
} from "../../api/userService";

const OLT_icon = "https://d3bn54rc14fhr4.cloudfront.net/ss.png";
const MEDIA_URL = "https://d3bn54rc14fhr4.cloudfront.net";

export default function ProfileSettings() {
  const [oldPassword, setOldPassword] = useState("");
  const { userId } = useParams();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [profilePic, setProfilePic] = useState(null);

  const [previewUrl, setPreviewUrl] = useState("");

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setPhone] = useState("");
  const [key, setKey] = useState("basicinfo");
  const navigate = useNavigate();
  const [user, setUsers] = useState({});

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const validTypes = ["image/jpeg", "image/png", "image/webp"];
      if (!validTypes.includes(file.type)) {
        toast.error("Only image files (jpg, png, webp) are allowed.");
        return;
      }

      setProfilePic(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await getProfile();
        if (response.data) {
          const { fullName, email, mobileNumber, profilePic } = response.data;
          setPreviewUrl(profilePic || "");
          setUsers(response.data);
          setName(fullName);
          setEmail(email);
          setPhone(mobileNumber);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          navigate("/login");
        } else {
          toast.error(error.message);
        }
      }
    };

    fetchProfile();
  }, []);

  const handleProfileUpdate = async (e) => {
    e.preventDefault();

    try {
      let profilePicUrl = previewUrl;

      if (profilePic) {
        const uploadData = new FormData();
        uploadData.append("document", profilePic);
        uploadData.append("folderPath", `${userId}/Profile`);

        const uploadRes = await fileUpload(uploadData);

        if (uploadRes?.status && uploadRes?.data?.url) {
          profilePicUrl = uploadRes.data.url;
          setPreviewUrl(uploadRes.data.url);
        } else {
          toast.error("Image upload failed");
          return;
        }
      }

      // Prepare final JSON for profile update
      const updatedData = {
        fullName: name,
        profilePicUrl: profilePicUrl,
        emergency_contact_no: "2222222222", // or bind to state if dynamic
      };

      const response = await updateProfile(userId, updatedData); // send as JSON

      if (response.status) {
        toast.success("Profile updated successfully");
        setUsers(response.data);
      } else {
        toast.error("Profile update failed");
      }
    } catch (error) {
      toast.error(error.message || "Error updating profile");
    }
  };

  const handlePasswordUpdate = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error("New password and confirm password do not match");
      return;
    }

    try {
      const response = await passwordChange(
        oldPassword,
        newPassword,
        confirmPassword
      );
      if (response.success === true) {
        toast.success("Password updated successfully");
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <React.Fragment>
      <Card>
        <Card.Header className="py-4">
          <h5>Profile Settings</h5>
        </Card.Header>
        <Card.Body>
          <Tabs
            defaultActiveKey="basicinfo"
            id="uncontrolled-tab-example"
            className="customtabs mb-2"
            activeKey={key}
            onSelect={(k) => setKey(k)}
          >
            <Tab eventKey="basicinfo" title="Basic Info">
              <Row>
                <Col md={5} xl={4} className="view_profile mb-3 ">
                  <div className="user_info text-center">
                    <div className="d-flex align-items-center justify-content-center">
                      <img
                        src={
                          previewUrl.startsWith("http")
                            ? previewUrl
                            : `${MEDIA_URL}/${previewUrl}`
                        }
                        alt="Profile Preview"
                        style={{
                          width: "150px",
                          height: "150px",
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                    <label
                      htmlFor="uploadprofileimg"
                      className="d-inline-block mt_30 btn btn-primary-outline px-4 font-size-14 lh-40"
                    >
                      Choose Picture
                    </label>
                    <input
                      type="file"
                      id="uploadprofileimg"
                      className="d-none"
                      accept=".jpg,.jpeg,.png,.webp"
                      onChange={handleFileChange}
                    />
                  </div>
                </Col>
                <Col md={7} xl={8}>
                  <Form onSubmit={handleProfileUpdate}>
                    <Row>
                      <Col lg={6}>
                        <Form.Group className="form-group mb-3">
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                          />
                        </Form.Group>
                      </Col>

                      <Col lg={6}>
                        <Form.Group className="form-group mb-3">
                          <Form.Label>User name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group className="form-group mb-3">
                          <Form.Label>Email Address</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="Enter email address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      {/* <Col lg={6}>
                                                <Form.Group className="form-group mb-3">
                                                    <Form.Label>Phone No.</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter phone no."
                                                        value={mobileNumber}
                                                        onChange={(e) => setPhone(e.target.value)}
                                                    />
                                                </Form.Group>
                                            </Col> */}
                    </Row>
                    <Button type="submit" className="btn btn-primary px-4 mt-3">
                      Update
                    </Button>
                  </Form>
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="changepassword" title="Change Password">
              <Row>
                <Col md={8} xl={9}>
                  <Form onSubmit={handlePasswordUpdate}>
                    <Row>
                      <Col lg={6}>
                        <Form.Group className="form-group mb-3">
                          <Form.Label>Current Password</Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="Current Password"
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group className="form-group mb-3">
                          <Form.Label>New Password</Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="New Password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group className="form-group mb-3">
                          <Form.Label>Confirm New Password</Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="Confirm New Password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Button
                      type="submit"
                      className="btn btn-primary px-4 mt-3"
                      disabled={
                        !oldPassword ||
                        !newPassword ||
                        !confirmPassword ||
                        newPassword !== confirmPassword
                      }
                    >
                      {" "}
                      Update
                    </Button>
                  </Form>
                </Col>
              </Row>
            </Tab>
          </Tabs>
        </Card.Body>
      </Card>
      <ToastContainer />
    </React.Fragment>
  );
}
